import { QueryClient as h } from "@tanstack/react-query";
import { j as e } from "./react-944c88e2.js";
import { extendTheme as j, ChakraProvider as g, Center as k, Spinner as P } from "@chakra-ui/react";
import { useMemo as w } from "react";
import { u as S } from "./eMyAsurionProvider-ec3ed988.js";
import "./firebase-d0134a8f.js";
import "./@firebase-868b0e52.js";
import "./node-forge-b3503c74.js";
import { getChakraColorScale as l } from "./myasurion-shared.colors.es.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import "./usehooks-ts-53aa4768.js";
import { t as n } from "./index-d9fb9451.js";
const D = new h({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
}), G = ({
  children: y,
  themeOverride: r = {}
}) => {
  const { data: o, isLoading: f } = S(), u = w(() => {
    var s, m;
    const { colors: t, baseComponents: x } = (o == null ? void 0 : o.theme) || {}, C = Object.fromEntries(
      Object.entries(x || {}).map(([i, b]) => {
        var p, a, c;
        return [
          i,
          {
            baseStyle: {
              ...((c = (a = (p = n) == null ? void 0 : p.components) == null ? void 0 : a[i]) == null ? void 0 : c.baseStyle) || {},
              ...b
            }
          }
        ];
      })
    ), T = {
      ...n.components,
      ...C
    };
    return j({
      ...n,
      colors: {
        ...n.colors,
        primary: l(((s = r == null ? void 0 : r.color) == null ? void 0 : s.primary) || (t == null ? void 0 : t.primary)),
        onPrimary: l(
          ((m = r == null ? void 0 : r.color) == null ? void 0 : m.onPrimary) || (t == null ? void 0 : t.onPrimary)
        ),
        primaryText: t == null ? void 0 : t.bodyTextColor
      },
      semanticTokens: {
        ...n.semanticTokens,
        colors: {
          ...n.semanticTokens.colors,
          ...o.theme.colors.bodyTextColor ? {
            "chakra-body-text": {
              _light: o.theme.colors.bodyTextColor || "#000000"
            }
          } : {}
        }
      },
      components: T
    });
  }, [o]);
  return /* @__PURE__ */ e.jsx(g, { theme: u, children: f && (o == null ? void 0 : o.local) === "true" ? /* @__PURE__ */ e.jsx(k, { h: "100vh", children: /* @__PURE__ */ e.jsx(P, { size: "lg" }) }) : y });
};
export {
  G as T,
  D as q
};
